import { List } from 'immutable';
import { DesignTemplates } from 'records/DesignTemplate';
import BaseList from 'records/BaseList';

import {
  ENLARGE_VIEW_TEMPLATES_ASYNC_ACTION_START,
  ENLARGE_VIEW_TEMPLATES_ASYNC_ACTION_ERROR,
  ENLARGE_VIEW_TEMPLATES_ASYNC_ACTION_SUCCESS,
  ENLARGE_VIEW_TEMPLATES_RESET_STATE,
} from 'actions/enlargeViewDesignTemplates';

const initialState = new BaseList({
  loading: false,
  errorMessage: null,
  data: new List(),
});

const actionsMap = {
  [ENLARGE_VIEW_TEMPLATES_ASYNC_ACTION_START]: (state) => {
    return state.merge({
      loading: true,
      errorMessage: null,
    });
  },
  [ENLARGE_VIEW_TEMPLATES_ASYNC_ACTION_ERROR]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: action.error,
    });
  },
  [ENLARGE_VIEW_TEMPLATES_ASYNC_ACTION_SUCCESS]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: null,
      data: DesignTemplates(action.data),
    });
  },
  [ENLARGE_VIEW_TEMPLATES_RESET_STATE]: () => {
    return initialState;
  },
};

export default function enlargeViewDesignTemplates(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
